import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useAppSelector } from '@/app/store';

interface BrandLogoProps {
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
}

export const BrandLogo: FC<BrandLogoProps> = ({ width = 130, height = 32, className, onClick }) => {
  const brandLogo = useAppSelector((state) => state.initial.brendLogo);
  const showBrandLogo = useAppSelector((state) => state.initial.settings.showBrandLogo);

  if (!brandLogo || !showBrandLogo) return null;

  return (
    <img
      width={width}
      height={height}
      alt='logo'
      src={`${import.meta.env.VITE_API_MINIO_URL}/${brandLogo.bucketName}/${brandLogo.originalObjectName}`}
      className={cn('object-cover shrink-0', onClick && 'cursor-pointer', className)}
      style={{ width, height }}
      onClick={onClick}
    />
  );
};
